/* Utils */
import { generateRequestActionCreator } from '../utils/generators/actionGenerators';

/* ActionTypes */
import {
  FETCH_CONTENT_BY_ID,
  UPDATE_CONTENT_PROGRESS,
  FETCH_VOD_CONTENT_MOVIE_PROGRESS,
} from './actionTypes';

export const fetchContentById = generateRequestActionCreator(
  ({ contentId }) => ({
    type: FETCH_CONTENT_BY_ID,
    payload: {
      contentId,
    },
  }),
);

export const fetchVodContentMovieProgress = (vmsId, vrioAssetId) => ({
  type: FETCH_VOD_CONTENT_MOVIE_PROGRESS,
  payload: { vmsId, vrioAssetId },
});

export const updateVodContentProgress = (contentId, progress) => ({
  type: UPDATE_CONTENT_PROGRESS,
  payload: { id: contentId, progress },
});
